export const EXSBSETTLEMENT_DELETE_RESET = 'EXSBSETTLEMENT_DELETE_RESET'
export const EXSBSETTLEMENT_DELETE_SET_ERROR = 'EXSBSETTLEMENT_DELETE_SET_ERROR'
export const EXSBSETTLEMENT_DELETE_SET_DELETED = 'EXSBSETTLEMENT_DELETE_SET_DELETED'
export const EXSBSETTLEMENT_DELETE_TOGGLE_LOADING = 'EXSBSETTLEMENT_DELETE_TOGGLE_LOADING'
